<article class="m-accordion-group">
    <header v-if="hasTitleSlot() || !concurrent"
         class="m-accordion-group__header"
         :class="{
            'm--no-title' : !hasTitleSlot(),
            'm--has-secondary-content' : hasSecondaryContentSlot(),
            'm--is-toggle-link-left' : toggleLinkLeft
         }">
        <div v-if="hasTitleSlot()"
             class="m-accordion-group__header-title">
            <slot name="title" />
        </div>
        <div class="m-accordion-group__secondary-content">
            <slot name="secondary-content" />
            <div class="m-accordion-group__toggle-link"
                 v-if="!concurrent && !disabled">
                <m-link v-if="!isAllOpen"
                        :mode="linkModeButton"
                        @click="openAllAccordions()"
                        ref="openAllButton">
                    {{ $i18n.translate('m-accordion-group:open-all') }}
                </m-link>
                <template v-if="!isAllOpen && !isAllClosed">&nbsp;&nbsp;|&nbsp;&nbsp;</template>
                <m-link v-if="!isAllClosed"
                        :mode="linkModeButton"
                        @click="closeAllAccordions"
                        ref="closeAllButton">
                    {{ $i18n.translate('m-accordion-group:close-all') }}
                </m-link>
            </div>
        </div>
    </header>
    <div class="m-accordion-group__body">
        <slot :groupRef="$vnode.componentInstance" />
    </div>
</article>
